import React from 'react'
import { Button, Container, Box, Grid, useMediaQuery } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import PhoneIcon from '@material-ui/icons/Phone'
import Logo from '../../assets/Ads Logo_DarkMode.svg'
import image1SVG from '../../assets/Illustrations/Platform.svg'
import image2SVG from '../../assets/Illustrations/Video.svg'
import image3SVG from '../../assets/Illustrations/Dashboard.svg'
import image4SVG from '../../assets/Illustrations/UserFriendly.svg'
import Desktop from '../../assets/Desktop.png'
import scroll from '../../assets/Icons/scroll.svg'
import './Landing.css'
import Copyright from 'components/Copyright/Copyright'

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      textDecoration: 'none',
      textTransform: 'none'
    }
  },
  call: {
    '& > *': {
      marginTop: theme.spacing(4)
    }
  }
}))
export default function LandingPage() {
  const mobile = useMediaQuery('(max-width: 600px)')
  const classes = useStyles()
  return (
    <div className="landingpage">
      <meta name="theme-color" content="#1C1E33" />
      <Container>
        <div className="showcase">
          <header>
            <Container className="header-container">
              <img className="logo" src={Logo} alt="logo" />
              {mobile ? (
                <div className={classes.root}>
                  <Button
                    component={Link}
                    to="/signin"
                    className={classes.button}
                    variant="contained"
                    size="large"
                    disableElevation>
                    <ExitToAppIcon />
                  </Button>
                  <Button
                    component={Link}
                    to="/signup"
                    variant="contained"
                    color="primary"
                    size="large"
                    disableElevation>
                    <PersonAddIcon />
                  </Button>
                </div>
              ) : (
                <div className={classes.root}>
                  <Button
                    component={Link}
                    to="/signin"
                    className={classes.button}
                    variant="contained"
                    startIcon={<ExitToAppIcon />}
                    disableElevation>
                    Log in
                  </Button>
                  <Button
                    component={Link}
                    to="/signup"
                    variant="contained"
                    color="primary"
                    startIcon={<PersonAddIcon />}
                    disableElevation>
                    Create Account
                  </Button>
                </div>
              )}
            </Container>
          </header>
          <Grid container className="text">
            <Grid className="herotext" item sm={12} md={6} lg={6}>
              <h3>
                MyTV+ <br />
                Advertising Platform
              </h3>
              <p>
                Manage your ad accounts, Artworks and the campaigns you have –
                <span className="underline1"> all in one place.</span>
              </p>
              <Box className={classes.call}>
                <Button
                  variant="contained"
                  component="a"
                  href="mailto:support@mytvadz.com"
                  color="primary"
                  startIcon={<PhoneIcon />}
                  disableElevation>
                  Contact Us
                </Button>
              </Box>
            </Grid>
            <Grid className="heroimage" item xs={12} sm={12} md={6} lg={6}>
              <img className="bodyimg" src={Desktop} alt="hero" />
            </Grid>
          </Grid>
          <img className="scroll-icon" alt="scroll icon" src={scroll} />
        </div>

        <div className="info">
          <h1 className="whyus">
            <div style={{ color: '#f50057' }}>Why</div>
            <br />
            MyTV+ <div className="underline2">Advertising</div> Platform?
          </h1>
          <div className="infosection">
            <div
              className="infoimg infoimg-left"
              style={{ position: 'relative' }}>
              <div className="red-bloom" />
              <img
                className="infoimg-svg svg-right"
                src={image1SVG}
                alt="hero"
              />
            </div>
            <div className="infotext">
              <h4>All in One</h4>
              Do all the advertisements for your business in one platform to
              reach everyone and everywhere.
            </div>
          </div>
          <div className="infosection">
            <div className="infotext">
              <h4>The Best Way</h4>
              The best way to put your ads on all the local TV channels from one
              platform instead of spending times on different agencies and
              people.
            </div>
            <div
              className="infoimg infoimg-right"
              style={{ position: 'relative' }}>
              <div className="green-bloom" />
              <img className="infoimg-svg" src={image2SVG} alt="hero" />
            </div>
          </div>
          <div className="infosection">
            <div
              className="infoimg infoimg-left"
              style={{ position: 'relative' }}>
              <div className="bloom" />
              <img
                className="infoimg-svg svg-right"
                src={image3SVG}
                alt="hero"
              />
            </div>
            <div className="infotext">
              <h4>More Analytics</h4>
              Get in depth analytic for your campaigns and it is performing with
              a very nice visualisation and manage your expectations
            </div>
          </div>
          <div className="infosection">
            <div className="infotext">
              <h4>Easy to Use</h4>A very user friendly campaign creation in
              minutes. And the way you like it to appear
            </div>
            <div
              className="infoimg infoimg-right"
              style={{ position: 'relative' }}>
              <div className="purple-bloom" />
              <img className="infoimg-svg" src={image4SVG} alt="hero" />
            </div>
          </div>
        </div>
      </Container>
      <footer>
        <div className="top-footer">
          <h4 className="footer-text">
            Get your free account and start bringing in customers
          </h4>
          <Box className="footer-button">
            <Button
              component={Link}
              to="/signup"
              variant="contained"
              color="primary"
              startIcon={<ExitToAppIcon />}
              disableElevation>
              Create Account
            </Button>
          </Box>
        </div>
        <div className="bottom-footer">
          <img className="logo footer-logo" src={Logo} alt="logo" />
          <Copyright />
        </div>
      </footer>
    </div>
  )
}
